// Un error de la API en palabras humanas, en el idioma de la persona, con su referencia.
import { ApiError } from "@responia/api/cliente";
import { useT } from "./useT";

export function useError() {
  const t = useT();
  return (e: unknown) => {
    const err = e instanceof ApiError ? e : new ApiError(0, "interno");
    const clave = `error.${err.codigo}`;
    return { titulo: t(clave), ref: err.ref ? t("error.referencia", { ref: err.ref }) : "" };
  };
}

export function MensajeError({ error, className }: { error: unknown; className?: string }) {
  const m = useError()(error);
  return (
    <div role="alert" className={className}>
      <p className="text-non">{m.titulo}</p>
      {m.ref && <p className="mt-1 text-xs text-encre-3 tabular-nums">{m.ref}</p>}
    </div>
  );
}
